import chainSvg from "./link-solid.svg?url";

export const chainIcon = chainSvg + "#link-solid";
